import { isEmpty } from 'lodash';
import {
  ACCOUNT_ID_IDENTIFIER,
  STATIC_ACCOUNT_ID,
  STATIC_ACCOUNT_ID_TYPES,
} from '../../../../../store/constants/accountIdConfigTypes';
import { getSecondAccountIdConfigForSupplierRetailer } from '../../../../../services/accountIdService';

export function getInitialAccountIdConfigFormState(initialAccountIdConfig, props = {}) {
  if (isEmpty(initialAccountIdConfig)) return defaultFormState;

  if (STATIC_ACCOUNT_ID_TYPES.includes(initialAccountIdConfig.type)) {
    const { value = ['', ''] } = initialAccountIdConfig;
    return {
      ...initialAccountIdConfig,
      value: Array.isArray(value) ? value[0] || '' : value,
      second_account_id_value: Array.isArray(value) ? value[1] : '',
    };
  }

  convertConfigMappingValuesToArrayTypesIfNeeded(initialAccountIdConfig, props);

  if (initialAccountIdConfig.identifier === ACCOUNT_ID_IDENTIFIER.SHIP_TO_COUNTRY) {
    // return handle
  }

  return initialAccountIdConfig;
}

function convertConfigMappingValuesToArrayTypesIfNeeded(accountIdConfig, props) {
  const secondAccountIdConfig = getSecondAccountIdConfigForSupplierRetailer(props.accountIdTypes);
  if (!secondAccountIdConfig.shouldShowSecondAccountIdInput) return;
  if (Object.values(accountIdConfig?.mapping).every(isEmpty)) return;

  Object.entries(accountIdConfig.mapping).forEach(([key, val]) => {
    if (!Array.isArray(val)) {
      accountIdConfig.mapping[key] = [val || '', ''];
    }
  });
}

const defaultFormState = {
  type: STATIC_ACCOUNT_ID,
  value: '',
  second_account_id_value: '',
  identifier: ACCOUNT_ID_IDENTIFIER.WAREHOUSE,
  mapping: {},
};
